import { Link, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { ChevronDown, LogOut, UserRound } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import telegramLogo from "@/assets/telegram.svg";
import api from "@/api/axios";
import ThemeToggle from "@/components/ThemeToggle";

export default function HeaderBar({ showLogo = true }: { showLogo?: boolean }) {
  const { token, setToken } = useAuth();
  const navigate = useNavigate();
  const [nickname, setNickname] = useState<string | null>(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!token) {
      setNickname(null);
      return;
    }
    api.get("/api/userinfo").then(({ data }) => {
      if (data.success) setNickname(data.data.user_nickname);
    }).catch(() => setNickname(null));
  }, [token]);

  useEffect(() => {
    const closeOnOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) setMenuOpen(false);
    };
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") setMenuOpen(false);
    };
    document.addEventListener("mousedown", closeOnOutside);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("mousedown", closeOnOutside);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, []);

  const logout = () => {
    document.cookie = "token=; path=/; max-age=0";
    setToken(null);
    setMenuOpen(false);
    navigate("/login");
  };

  return (
    <header className="site-header public-header">
      {showLogo && <Link to="/" className="public-header-brand"><img src={telegramLogo} alt="" /><strong>TG Checkin</strong></Link>}
      <nav className="public-header-actions" aria-label="主导航">
        <Link to="/help" className="public-header-link">使用指南</Link>
        <ThemeToggle />
        {token ? <div className="public-header-account" ref={menuRef}>
          <button type="button" className="public-header-account-button" aria-expanded={menuOpen} aria-haspopup="menu" onClick={() => setMenuOpen((open) => !open)}><UserRound size={17} /><span>{nickname || "我的账户"}</span><ChevronDown size={15} /></button>
          {menuOpen && <div className="public-header-menu" role="menu"><Link to="/dashboard" role="menuitem" onClick={() => setMenuOpen(false)}>个人中心</Link><button role="menuitem" type="button" onClick={logout}><LogOut size={15} />退出登录</button></div>}
        </div> : <><Link to="/login" className="public-header-link">登录</Link><Link to="/register" className="public-header-register">注册</Link></>}
      </nav>
    </header>
  );
}
